export enum TransportType {
  CarriageOfGoods = 0,
  CarriageOfPeople = 1,
}
